<template>
  <div class="individuelle-anforderungen">
   <div class="container col12">
      <div :class="{'rw-tabs': !loading, vertical: true}">
        <div class="tabset">
          <div class="tab active">
            Anforderungen
          </div>
        </div>
        <div class="tabs-container">
          <div class="tab-content">
            <div class="row">
              <div class="col-left">
                Produktionsmenge (bezogen auf 1-flügelige Einheiten = 8 Teile) inklusive Bohrungen
              </div>
              <div class="col-right">
                <config-option v-model="anforderungen.leistung" :options="produktionsmenge" class="row" @change="$emit('change')" />
              </div>
            </div>
            <div class="row">
              <div class="col-left">
                Eckverbindungen
              </div>
              <div class="col-right">
                <config-option v-model="anforderungen.eckverbindungen" :options="eckverbindungen" multiple class="row" @change="$emit('change')" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Options from '@/Options'
import ConfigOption from '@/components/ConfigOption'

export default {
  name: 'IndividuelleAnforderungen',
  components: {
    ConfigOption
  },
  data () {
    return {
      anforderungen: this.data || {leistung: '0-10', eckverbindungen: new Set()},
      loading: true,
      eckverbindungen: {},
      produktionsmenge: {
        '0-10': '0-10 Einheiten / Schicht (Std)',
        '10-15': '10-15 Einheiten / Schicht (Std)',
        '15-22': '15-22 Einheiten / Schicht (Std)',
        '22-30': '22-30 Einheiten / Schicht (Std)',
        '30-50': '30-50 Einheiten / Schicht (Std)',
        '50-70': '50-70 Einheiten / Schicht (Std)',
        '70+': 'Mehr als 70 Einheiten / Schicht (Std)'
      }
    }
  },
  methods: {
    getAnforderungen () {
      return {
        leistung: this.anforderungen.leistung,
        eckverbindungen: Array.from(this.anforderungen.eckverbindungen)
      }
    },
    setAnforderungen (data) {
      this.anforderungen.leistung = data.leistung
      this.anforderungen.eckverbindungen = new Set(data.eckverbindungen)
    }
  },
  created () {
    Options.getOptions().then(options => {
      this.eckverbindungen = options.eckverbindungen
      this.loading = false
    })
  },
  computed: {
  },
  watch: {
    data (val) {
      this.anforderungen = val
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content {
  padding-bottom: 36px;
  padding-top: 12px !important;
  padding-left: 0 !important;
}

label {
  padding-left: 24px;
}

.row::after {
  content: '';
  display: table;
  clear: both;
}

.row {
  padding-left: 24px;
  padding-right: 24px;
}

.row:hover {
  background-color: rgba(230,230,230, 0.3);
}

.row .row {
  background-color: transparent !important;
  padding-right: 0;
}

.row > .col-left {
  padding: 12px 0;
  @media screen and (min-width: 768px) {
    float: left;
    width: 20%;
  }
}

.row > .col-right {
  @media screen and (min-width: 768px) {
    float: left;
    width: 80%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/IndividuelleAnforderungen.vue